module.exports = __webpack_public_path__ + "img/planet.4b8194a4.png";